import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RfisService implements OnDestroy {

  search: Subject<any> = new Subject();

  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor() {

  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }


}
